module.exports = __webpack_public_path__ + "static/media/dot_009AEE_a.4f760cce.svg";